import { getKeys } from './getKeys'

export const privacyOfficersTranslations = {
  PRIVACY_OFFICERS: 'Privacy Officers',
  EDITING_PRIVACY_OFFICERS: 'Editing Privacy Officers',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  EDIT: 'Edit',
  SINCE: 'since ',
  CLOSE: 'CLOSE',
  THESE_USERS: 'These users will also have Privacy Officer access rights.',
  YOU_MUST: 'You must select at least one user to be a Privacy Officer.',
  PRIVACY_OFFICER: 'Privacy Officer',
  THIS_USER: 'This user is a Privacy Officer',
  TO_MAKE_SENSE:
    'To make these changes first remove this user from Privacy Officer list under the Settings here.',
  USERS_WHO_ARE:
    'Users who are set as a Home’s Privacy Officer cannot be deleted or have their role changed.',
  BELOW_LISTS:
    'Below lists administrators who have Privacy Officer access rights',
}

export const privacyOfficersConstants = getKeys(privacyOfficersTranslations)
